import { ROSEError, ROSEReject } from "../../web-shared-components/asn1/EUCSrv/stubs/SNACCROSE";
import { ILogCallback, ILogData } from "../../web-shared-components/helpers/logger/ILogger";
import { IBaseSingletons } from "../interfaces/IBaseSingletons";
import BaseSingleton from "../lib/BaseSingleton";
import { SocketTransport } from "../session/SocketTransport";

/**
 * This Manager takes care about the operations related to the logged-in user.
 */
export class MeManager extends BaseSingleton implements ILogCallback {
	// The singleton instance of this class
	private static instance: MeManager;
	private socket: SocketTransport;

	/**
	 * Constructs MeManager.
	 * Method is private as we follow the Singleton Approach using getInstance
	 * @param attributes - the constructor attributes
	 */
	private constructor(attributes: IBaseSingletons) {
		super(attributes);
		this.socket = SocketTransport.getInstance();
	}

	/**
	 * Gets instance of MeManager to use as singleton.
	 * @param attributes - the constructor attributes
	 * @returns - an instance of this class.
	 */
	public static getInstance(attributes: IBaseSingletons): MeManager {
		if (!MeManager.instance) MeManager.instance = new MeManager(attributes);
		return MeManager.instance;
	}

	/**
	 * The Loggers getLogData callback (used in all the log methods called in this class, add the classname to every log entry)
	 * @returns - an ILogData log data object provided additional data for all the logger calls in this class
	 */
	public getLogData(): ILogData {
		return {
			className: "MeManager"
		};
	}

	/**
	 * getServerBasedClientSettings(V1) DEPRECATED
	 * @returns - Document or EError
	 */
	public async getServerBasedClientSettings(): Promise<Document | Error> {
		const argument = { _type: "AsnGetServerBasedClientSettingsArgument" };
		return new Promise((resolve) => {
			const callBack = (result: unknown) => {
				if (result instanceof ROSEError || result instanceof ROSEReject) {
					this.logger.error("Error getServerBasedClientSettings", "getServerBasedClientSettings", this, { result });
					resolve(new Error("Error getServerBasedClientSettings"));
				} else {
					const domParser = new DOMParser();
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					const resGetServerBasedClientSettings: any = result as any;

					const sSettingsData: string = resGetServerBasedClientSettings.clientSettings.osSettingsData as string;

					const xmlRoot = domParser.parseFromString(sSettingsData, "application/xml");
					resolve(xmlRoot);
				}
			};
			this.socket.send("asnGetServerBasedClientSettings", argument, callBack);
		});
	}
}
